import Bouncer from 'formbouncerjs';
import {
  isFormProcessing,
  markFormProcessing,
  feedbackErr,
  feedback,
  feedbackClear,
  grecaptchaV3Execute,
  logToPHP,
} from './scripts';
import {
  subscribeToEveryAction,
} from './ea';

const $j = jQuery.noConflict();
const footerSlot = '#br';
const mobileFooterSlot = '#scroll-to-enews-form';
const cookieName = 'dockFloatingForm';
const idWhereForceDockClassWouldBe = 'colophon';
const bouncers = {};

function hideEnewsForm(submittingForm) {
  const submittingFormId = submittingForm.attr('id');

  if (submittingFormId === 'enewsForm') {
    // floating form
    submittingForm.find('.form-grid-section, button[name="subscribe"]').hide();
  } else if (submittingFormId === 'enewsFloatingForm') {
    // floating form
    submittingForm.find('input, button[name="subscribe"]').closest('.input-wrapper').hide();
  } else if (submittingFormId === 'catalog-order-form') {
    // main page form
    submittingForm.find('.order-form-sub-area').hide();

    // order form
    submittingForm.find('h2').hide();
  } else {
    // eslint-disable-next-line no-console
    console.err(`error hiding ${submittingFormId}`);
  }
}

// ////////////////////////////////////////
// Docking

function dockToScreen(shouldDock) {
  const m = $j(mobileFooterSlot);
  const f = $j(footerSlot);
  const r = $j('#enewsFloatingFormRestorerWrapper');
  const els = [m, f, r];

  if (shouldDock) {
    // console.log('screen showing docked the floating form.');

    els.forEach((el) => {
      if (el.hasClass('initial-state')) {
        el.removeClass('initial-state');
      }
    });

    return;
  }

  // console.log('screen showing undocked the floating form.');

  els.forEach((el) => {
    if (!el.hasClass('initial-state')) {
      el.addClass('initial-state');
    }
  });
}

function dockToCookies(shouldDock) {
  if (shouldDock) {
    // console.log('cookie to dock the floating form.');
    document.cookie = `${cookieName}=true; path=/; max-age=86400`;
    return;
  }

  // console.log('cookie to undock the floating form.');
  document.cookie = `${cookieName}=; path=/; max-age=0`;
}

function dock(shouldDock) {
  dockToCookies(shouldDock);
  dockToScreen(shouldDock);
}

function dockOrNot() {
  if ($j(`#${idWhereForceDockClassWouldBe}`).hasClass('force-dock')) {
    // console.log('force screen showing docked floating form');
    dockToScreen(true);
    return;
  }

  const shouldDock = (document.cookie.split(';').filter((item) => item.trim().startsWith(`${cookieName}=true`)).length);
  dock(shouldDock);
}

async function processEnewsForm(submittingForm) {
  const arrayOfInvalidElements = bouncers[submittingForm.attr('id')].validateAll(submittingForm[0]);
  if (
    !Array.isArray(arrayOfInvalidElements)
    || arrayOfInvalidElements.length > 0
  ) {
    // console.error('form not valid');
    markFormProcessing(submittingForm, false);
    return;
  }

  feedback(submittingForm, 'Processing&hellip;');
  const gaction = 'enews_submit';
  const gresponse = await grecaptchaV3Execute(gaction);

  if (
    !Object.prototype.hasOwnProperty.call(gresponse, 'success')
    || !gresponse.success
  ) {
    feedbackErr(submittingForm, 'Sorry. There was a problem processing your request.');
    markFormProcessing(submittingForm, false);
    return;
  }

  $j('.submitter').blur();
  let eaResponse;

  try {
    eaResponse = await subscribeToEveryAction(submittingForm);
  } catch (err) {
    feedbackErr(submittingForm, 'Sorry. There was an error processing your subscription. Please try again later.');
    logToPHP(`subscribeToEveryAction error: ${JSON.stringify(err)}`);
    markFormProcessing(submittingForm, false);
    return;
  }

  if (!eaResponse.success) {
    feedbackErr(submittingForm, 'Sorry. There was an error creating your subscription. Please try again later.');
    markFormProcessing(submittingForm, false);
    return;
  }

  feedback(submittingForm, eaResponse.msg);
  hideEnewsForm(submittingForm);
}

function scrollToEnewsFormInFooter() {
  const target = $j('#br').offset().top - 20;
  $j('html, body').animate({
    scrollTop: target,
  }, 1000);
}

// Docking
// ////////////////////////////////////////

$j(() => {
  dockOrNot();

  $j('#enewsFloatingFormRestorer').click((e) => {
    e.preventDefault();
    dock(false);
  });

  $j('#scroll-to-enews-form a').click(() => {
    dock(true);
    scrollToEnewsFormInFooter();
  });

  $j('#enewsFloatingFormDismisser, #enewsLinkToFormDismisser').click(() => {
    dock(true);
  });

  bouncers.enewsForm = new Bouncer('#enewsForm', {
    disableSubmit: true,
  });

  bouncers.enewsFloatingForm = new Bouncer('#enewsFloatingForm', {
    disableSubmit: true,
  });

  // Attach submit handlers to the form
  $j('#enewsForm, #enewsFloatingForm').find('button[name="subscribe"]')
    .click(async function handleEnewsClick(event) {
      event.preventDefault();
      const submittingForm = $j(this).closest('form');

      if (isFormProcessing(submittingForm)) {
        feedbackErr(submittingForm, 'Hold on, still processing&hellip;');
        return;
      }

      markFormProcessing(submittingForm, true);
      $j(this).blur();
      feedbackClear(submittingForm);
      await processEnewsForm(submittingForm);
    });
});
